<!--
================================================
Un composant afifchant un avis utilisateur
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->
<template>
  <div class="review">

    <div class="headline">

      <div class="quote" v-html="review.text">
      </div>

      <div class="stars">
        <font-awesome-icon v-for="index in review.stars" :key="index" :icon="['fas', 'star']" class="icon"/>
      </div>

      <img alt="author pic" height="96" width="96"  class="pic my-2" :src="require(`../assets/img/reviews/${review.pic}`)"/>
      <div class="author">
        {{ review.author }}
      </div>


      <div class="poste">{{ review.position }} <span v-if="review.company != null" class="company"> - {{review.company}}</span></div>

    </div>

  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++++ SCRIPT ++++++++++++++++++++++
-------------------------------------------------->
<script>

export default {
  name: "ReviewComp",

  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    review: Object, // objet représentant l'avis
  },
  data: function () {
    return {
    }
  },

  computed:{
  },

  methods: {
  },

  mounted: function () {
  }

}
</script>

<!------------------------------------------------
+++++++++++++++++++++ CSS ++++++++++++++++++++++++
-------------------------------------------------->
<style scoped lang="scss">
@import "../assets/css/globalVar";
@import "../assets/css/bulmaResponsiveDep";

.review{
  background-color: #fff;
  font-size: .95rem;
  border-radius: .3rem;
  transition: box-shadow .5s ease-in-out;
  position: relative;
  min-height: 25rem;

  @include mobile {
    margin-bottom: 4rem;
  }
  @include tablet{
    margin: 0 1rem;
  }
  @include desktop{
    margin: 0 1rem;
  }

  .stars{
    margin-top: .5rem;
    font-size: .9rem;
    text-align: center;
    .icon{
      margin-right: .2rem;
      color: $brandPrimary;
    }
  }

  .headline{
    color: $brandThird;

    .pic{
      background-color: white;
      background-size: cover;
      display: block;
      margin: auto;
      $size: 4rem;
      height:$size;
      width: $size;
      border-radius:$size;
      border:solid .3rem white;
    }

    .poste{
      font-weight: bold;
      .company{

        text-transform: capitalize;
        letter-spacing: .05rem;

        &:before{
        }
        color:$brandFourth;
      }
    }

  }

  .quote{
    position: relative;
    font-size: .9rem;
    color: $brandFourth;
    margin-top: 1rem; display: block;

    &:after{
      content: '"'; font-size: 4rem; color: #ddd;
      position: absolute; right: 0;
    }

    &:before{
      content: '"'; font-size: 4rem; color: #ddd;
      position: absolute; left: -1.5rem; top: -2rem;
    }

  }
}


</style>
